var map = {
	"./1/medal2.png": "h8AM",
	"./2/medal2.png": "vdsH",
	"./3/medal2.png": "hQPW",
	"./4/medal2.png": "TXCh",
	"./5/medal2.png": "4DQQ",
	"./6/medal2.png": "BKR0",
	"./7/medal2.png": "AtFm",
	"./8/medal2.png": "zqTm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2Mxd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/medal2\.png$
// module id = 2Mxd
// module chunks = 1